import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';

import { useWorkflow } from '../v2-hooks/useWorkflow';

export interface PublicationStatePanelViewModel {
  /** The workflow for the currently-open content. */
  readonly workflow: ContentWorkflow | undefined;
}

/** View model hook for the publication state side panel; exposes the open content's workflow. */
export function usePublicationStatePanelViewModel(): PublicationStatePanelViewModel {
  const workflow = useWorkflow();
  return { workflow };
}
